import { Grid, Tab, Tabs } from '@mui/material';
import withAuth from 'components/with-auth/with-auth';
import { MY, SHOP, WebRoute } from 'config/fe-routes';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { UserType } from 'types/user.types';
import { redirectTo } from 'utils/route-helpers';

export enum MyShopTabName {
  MY_SHOP = 'my-shop',
  MY_ORDERS = 'my-orders',
  DISCOUNT_CODES = 'discount-codes',
}

type MyShopTabsProps = {
  value: MyShopTabName;
  user?: UserType;
};

const mapStateToProps = ({ userData }) => ({
  user: userData && userData.user,
});

const MyShopTabs = (props: MyShopTabsProps) => {
  const { value, user } = props;
  const { t } = useTranslation();
  const tabs: Array<{ label: string; value: MyShopTabName; url: WebRoute }> = [
    {
      label: t('pages.my-shop.title'),
      value: MyShopTabName.MY_SHOP,
      url: SHOP(user?.shop?.activeSlug),
    },
    {
      label: t('pages.my-shop.orders'),
      value: MyShopTabName.MY_ORDERS,
      url: MY.ORDERS(),
    },
    {
      label: t('pages.my-shop.discountCodes'),
      value: MyShopTabName.DISCOUNT_CODES,
      url: MY.DISCOUNT_CODES(),
    },
  ];

  const handleTabChange = (tabValue: MyShopTabName) => {
    const selectedTab = tabs.find((tab) => tab.value === tabValue);

    redirectTo(selectedTab?.url);
  };

  return (
    <Grid container>
      <Tabs
        className="shop-tabs-container"
        value={value}
        centered={true}
        variant="fullWidth"
        textColor="inherit"
        indicatorColor="primary"
        onChange={(_, tabValue) => handleTabChange(tabValue)}
      >
        {tabs.map((tab) => (
          <Tab label={tab.label} value={tab.value} key={'my-shop-tab-' + tab.value} />
        ))}
      </Tabs>
    </Grid>
  );
};

export default connect(mapStateToProps)(withAuth(MyShopTabs));
